import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTrackAbandonedGift } from "@qgiv/donation-form";
import { selectReceivedHandshake } from "../../redux/slices/appSettingsSlice";
import { selectAllDonationSettings } from "../../redux/slices/donationSettingsSlice";
import { selectAbandonedGiftData } from "../../redux/slices/abandonedGiftSlice";
import { selectAllFormSettings } from "../../redux/slices/formSettingsSlice";
import { selectSubtotalGift } from "../../redux/slices/donationDetailsSlice";
import { selectHasActiveFulfillment } from "../../redux/slices/promiseTransactionSlice";
import { selectIsTextToDonate } from "../../redux/slices/smsDataSlice";

const ConnectedUseTrackAbandonedGift = () => {
    /* 
        Want to set up api calls to track gift progress
        1. If handshake is established
        2. If abandonedGifts is enabled
        3. Not fulfillment or T2D
        4. Include element interactions
    */
    const receivedHandshake = useSelector(selectReceivedHandshake);
    const donationSettings = useSelector(selectAllDonationSettings);
    const formSettings = useSelector(selectAllFormSettings);
    const abandonedGiftData = useSelector(selectAbandonedGiftData);
    const amount = useSelector(selectSubtotalGift);
    const hasActiveFulfillment = useSelector(selectHasActiveFulfillment);
    const isTextToDonate = useSelector(selectIsTextToDonate);

    const formId = formSettings.id;

    const { enableAbandonedGifts } = donationSettings;

    const {
        hasBeenPromptedToReturnToGift = false,
        hasScheduledEmailReminders = false,
    } = abandonedGiftData;
    const token = abandonedGiftData.qgiv_abandoned_gift;
    const firstName = abandonedGiftData.First_Name;
    const lastName = abandonedGiftData.Last_Name;
    const email = abandonedGiftData.Email;
    const emailReminderRecipient = abandonedGiftData.emailForReminders;

    const abandonedGiftTrackingData = useMemo(() => {
        const combinedAbandonedGiftTrackingData = {
            amount,
            token,
            formId,
            // only add these data points if they have a value
            ...(email && { email }),
            ...(firstName && { firstName }),
            ...(lastName && { lastName }),
            ...(emailReminderRecipient && { emailReminderRecipient }),
            // only add these data points if they are true
            ...(hasScheduledEmailReminders && { hasScheduledEmailReminders }),
            ...(hasBeenPromptedToReturnToGift && {
                hasBeenPromptedToReturnToGift,
            }),
        };
        return combinedAbandonedGiftTrackingData;
    }, [
        amount,
        email,
        emailReminderRecipient,
        firstName,
        formId,
        hasScheduledEmailReminders,
        hasBeenPromptedToReturnToGift,
        lastName,
        token,
    ]);

    const shouldSendTrackingData =
        amount > 0 &&
        enableAbandonedGifts &&
        receivedHandshake &&
        !hasActiveFulfillment &&
        !isTextToDonate;

    useTrackAbandonedGift({
        abandonedGiftTrackingData,
        formId,
        shouldSendTrackingData,
    });

    return null;
};

export default ConnectedUseTrackAbandonedGift;
